import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'src/utils/axiosCatalog';


export const getSiriusDefects = createAsyncThunk('/getSiriusDefects', async (kulModelKodu, garantiTipi) => {
  const response = await axios.get(`/GetSiriusDefects/${kulModelKodu}/${garantiTipi}`);
  return response.data;
});

export const getDefects = createAsyncThunk('/getDefects', async () => {
  const response = await axios.get('/GetDefects');
  return response.data;
});

export const getDefectDetails = createAsyncThunk(
  '/getDefectDetails',
  async id => {
    const response = await axios.get(`/GetDefectDetails/${id}`);
    return response.data;
  }
);

export const getLanguagelist = createAsyncThunk(
  '/getLanguageList',
  async () => {
    const response = await axios.get('/GetLanguageList');
    return response.data;
  }
);

export const getDefectCategories = createAsyncThunk(
  '/getDefectCategories',
  async () => {
    const response = await axios.get(`/GetDefectCategories`);
    return response.data;
  }
);

export const getDefectCategoryTypes = createAsyncThunk(
  '/getDefectCategoryTypes',
  async id => {
    const response = await axios.get(`/GetDefectCategoryTypes/${id}`);
    return response.data;
  }
);

export const getTenantDefect = createAsyncThunk(
  '/GetTenantMapData',
  async () => {
    const response = await axios.get('/GetTenantMapData');
    return response.data;
  }
);

export const getProductHierarchy = createAsyncThunk(
  '/getTopProductHierarchy',
  async () => {
    const response = await axios.get('/GetTopProductHierarchy');
    return response.data;
  }
);

const defectSlice = createSlice({
  name: 'defect',
  initialState: {
    loading: false,
    error: '',
    MainLanguageDescription: '',
    SiriusDefects: [],
    Defects: [],
    DefectDescriptions: [],
    ActiveDefectCategoryId: 0,
    ActiveDefectSubCategoryId: 0,
    SelectedDefectId: 0,
    SelectedDefect: [],
    SelectedAppTranslationId: 0,
    DefectCategories: [],
    DefectSubCategories: [],
    ProductGroups: [],
    DefectTenants: []
  },
  reducers: {
    changeSelectedAppTranslationId(state, action) {
      state.SelectedAppTranslationId = action.payload;
    },
    resetDescriptions(state) {
      state.Defects = [];
      state.DefectDescriptions = [];
      state.ActiveDefectCategoryId = 0;
      state.ActiveDefectSubCategoryId = 0;
      state.SelectedDefectId = 0;
      state.MainLanguageDescription = '';
      state.DefectTenants = [];
      state.SelectedDefect = [];
      state.ProductGroups = [];
      state.SelectedAppTranslationId = 0;
    },
    changeSelectedDefectId(state, action) {
      state.SelectedDefectId = action.payload;
    },
    changeSelectedDefect(state, action) {
      state.SelectedDefect = action.payload;
    },
    changeActiveDefectCategoryId(state, action) {
      state.ActiveDefectCategoryId = action.payload;
    },
    changeActiveDefectSubCategoryId(state, action) {
      state.ActiveDefectSubCategoryId = action.payload;
    },
    changeMainLanguageDescription(state, action) {
      state.MainLanguageDescription = action.payload;
    },
    changeDefectTenants(state, action) {
      state.DefectTenants = action.payload;
    },
    changeDefectProductGroups(state, action) {
      state.ProductGroups = action.payload;
    },
    changeDefectDescriptions(state, action) {
      state.DefectDescriptions = action.payload;
    }
  },
  extraReducers: {
    [getSiriusDefects.pending]: state => {
      state.loading = true;
    },
    [getSiriusDefects.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getSiriusDefects.fulfilled]: (state, action) => {
      state.SiriusDefects = action.payload;
      state.loading = false;
    },
    [getDefects.pending]: state => {
      state.loading = true;
    },
    [getDefects.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getDefects.fulfilled]: (state, action) => {
      state.Defects = action.payload;
      state.loading = false;
    },
    [getDefectDetails.pending]: state => {
      state.loading = true;
    },
    [getDefectDetails.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getDefectDetails.fulfilled]: (state, action) => {
      state.DefectDescriptions = action.payload;
      state.loading = false;
    },
    [getLanguagelist.pending]: state => {
      state.loading = true;
    },
    [getLanguagelist.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getLanguagelist.fulfilled]: (state, action) => {
      state.DefectDescriptions = action.payload;
      state.loading = false;
    },
    [getDefectCategories.pending]: state => {
      state.loading = true;
    },
    [getDefectCategories.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getDefectCategories.fulfilled]: (state, action) => {
      state.DefectCategories = action.payload;
      state.loading = false;
    },
    [getDefectCategoryTypes.pending]: state => {
      state.loading = true;
    },
    [getDefectCategoryTypes.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getDefectCategoryTypes.fulfilled]: (state, action) => {
      state.DefectSubCategories = action.payload;
      state.loading = false;
    },
    [getTenantDefect.pending]: state => {
      state.loading = true;
    },
    [getTenantDefect.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getTenantDefect.fulfilled]: (state, action) => {
      state.DefectTenants = action.payload;
      state.loading = false;
    },

    [getProductHierarchy.pending]: state => {
      state.loading = true;
    },
    [getProductHierarchy.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getProductHierarchy.fulfilled]: (state, action) => {
      state.ProductGroups = action.payload;
      state.loading = false;
    }
  }
});

export const defectActions = defectSlice.actions;

export default defectSlice;
